import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './applicable-product.component.html';
var ApplicableProductComponent = (function () {
    function ApplicableProductComponent() {
    }
    Object.defineProperty(ApplicableProductComponent.prototype, "sku", {
        get: function () {
            var _a;
            return (_a = this.product) === null || _a === void 0 ? void 0 : _a.sku;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicableProductComponent.prototype, "attributes", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.length) > 0 ? this.product.attributes : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicableProductComponent.prototype, "thumbnailUrl", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.length) > 0 ? this.product.images[0].url + "?w=160&h=160" : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicableProductComponent.prototype, "supportPageUrl", {
        get: function () {
            var _a;
            return ((_a = this.product) === null || _a === void 0 ? void 0 : _a.supportPageUrl) ? this.product.supportPageUrl + "#/#" + this.product.sku : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApplicableProductComponent.prototype, "productName", {
        get: function () {
            var _a;
            return (_a = this.product) === null || _a === void 0 ? void 0 : _a.productName;
        },
        enumerable: false,
        configurable: true
    });
    ApplicableProductComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ApplicableProductComponent.prototype, "product", void 0);
    ApplicableProductComponent = __decorate([
        Component({
            selector: 'applicableProduct',
            template: template,
        })
    ], ApplicableProductComponent);
    return ApplicableProductComponent;
}());
export { ApplicableProductComponent };
